import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useAnimation } from '../../hooks/useAnimation';
import countryService from '../../services/countryService';
import config from '../../config';
import defaultLogo from '../../assets/images/tekstas-logo.svg';
import './Fairs.scss';

const Fairs = () => {
  const { t } = useTranslation();
  const { slideInLeft, slideInRight, fadeOnly, staggerContainer } = useAnimation();
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasFetched = useRef(false);
  
  // Zigzag pattern için animasyon variant'ları
  const zigzagVariants = [slideInLeft, slideInRight, slideInLeft];
  
  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    
    console.log('Fairs component: Fetching countries...');
    
    const fetchCountries = async () => {
      try {
        setLoading(true);
        const data = await countryService.getCountries();
        console.log('Fairs component: Countries fetched successfully:', data.length);
        setCountries(data);
      } catch (err) {
        console.error('Error fetching countries:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, []);

  if (loading) {
    return (
      <section className="fairs-section">
        <div className="section-title">
          <h2>{t('fairs.title')}</h2>
          <p>{t('fairs.subtitle')}</p>
        </div>
        <div className="container">
          <div className="text-center">
            <p>Yükleniyor...</p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="fairs-section">
        <div className="section-title">
          <h2>{t('fairs.title')}</h2>
          <p>{t('fairs.subtitle')}</p>
        </div>
        <div className="container">
          <div className="text-center">
            <p>Ülkeler yüklenirken hata oluştu: {error}</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="fairs-section">
      <motion.div
        className="section-title"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.3 }}
        variants={fadeOnly}
      >
        <h2>{t('fairs.title')}</h2>
        <p>{t('fairs.subtitle')}</p>
      </motion.div>
      
      <div className="container">
        <motion.div
          className="fairs-wrapper"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
        >
          {countries.slice(0, 3).map((country, index) => (
            <motion.div
              key={country.id}
              className="fair-item"
              variants={zigzagVariants[index]}
            >
              <img 
                src={country.cover_image ? 
                  (country.cover_image.startsWith('/api/') ? 
                    `${config.API_URL}${country.cover_image.replace('/api', '')}` : 
                    `${config.API_URL}${country.cover_image}`
                  ) : 
                  defaultLogo
                } 
                alt={country.name} 
                onError={(e) => {
                  e.target.src = defaultLogo;
                }}
              />
              <div className="fair-content">
                <h3>{country.name}</h3>
                <p>{country.description || 'Fuar bilgisi'}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
        
        <motion.div
          className="text-center mt-5"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
          variants={fadeOnly}
          transition={{ delay: 0.5 }}
        >
          <Link to="/exhibitions" className="schedule-btn">{t('fairs.view_all')}</Link>
        </motion.div>
      </div>
    </section>
  );
};

export default Fairs;